var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "Tooltip",
    class: {
      'Tooltip--visible': _vm.getIsVisible,
      'Tooltip--inMenu': _vm.inMenu
    },
    style: {
      backgroundColor: _vm.backgroundColor,
      color: _vm.color,
      maxWidth: ((_vm.maxWidth) + "px")
    },
    attrs: {
      "id": 'js-tooltip-' + _vm.inputId
    }
  }, [_c('span', {
    staticClass: "Tooltip-triangle",
    class: {
      'Tooltip-triangle--inMenu': _vm.inMenu
    },
    style: {
      borderColor: _vm.getBorderColor
    },
    attrs: {
      "id": 'js-tooltip-triangle-' + _vm.inputId
    }
  }), _vm._v(" " + _vm._s(_vm.label) + " ")]);
}
var staticRenderFns = []

export { render, staticRenderFns }